import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { getFrasesRespuestaThunk } from "../../store/reducers/frasesRespuesta/frasesRespuesta.thunks";
import FrasesRespuestaHeader from "../../components/frasesRespuesta/FrasesRespuestaHeader";
import FrasesRespuestaTable from "../../components/frasesRespuesta/FrasesRespuestaTable";
import FraseRespuestaViewModal from "../../components/frasesRespuesta/FraseRespuestaViewModal";
import FraseRespuestaEditModal from "../../components/frasesRespuesta/FraseRespuestaEditModal";
import Loader from "../../components/UI/Loader";
import Alert from "../../components/UI/Alert";
import Pagination from "../../components/UI/Pagination";
import {
  clearError,
  setPage,
} from "../../store/reducers/frasesRespuesta/frasesRespuesta.reducer";

const FrasesRespuestaPage = () => {
  const dispatch = useDispatch();
  const {
    list,
    loading,
    error,
    page,
    count,
    search,
  } = useSelector((state) => state.frasesRespuesta);

  useEffect(() => {
    dispatch(getFrasesRespuestaThunk({ page, search }));
  }, [dispatch, page, search]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <FrasesRespuestaHeader />

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearError())}
          />
        )}

        {loading ? (
          <Loader center text="Cargando frases respuesta..." delay={200} />
        ) : (
          <>
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            <FrasesRespuestaTable frasesRespuesta={list} search={search} />

            {count > 0 && (
              <Pagination
                page={page}
                count={count}
                pageSize={10}
                onPageChange={handlePageChange}
              />
            )}
          </>
        )}
      </div>

      {/* Modales */}
      <FraseRespuestaViewModal />
      <FraseRespuestaEditModal />
    </div>
  );
};

export default FrasesRespuestaPage;
